import type { CSSProperties } from 'react'

import classNames from '../../utils/classNames'
import { TailSpin } from '../loaders'

interface SpinnerProps {
  containerStyle?: CSSProperties
  spinnerSize?: number
  className?: string
}

const Spinner = ({ containerStyle, spinnerSize, className }: SpinnerProps) => {
  return (
    <div
      className={classNames('flx-ctr w-full', className)}
      style={containerStyle}>
      <TailSpin
        color={'#00A6FF'}
        width={spinnerSize ?? 40}
        height={spinnerSize ?? 40}
      />
    </div>
  )
}

export default Spinner
